export default __webpack_public_path__ + "resources/icons/d340-0c41.png";